<template>
  <van-popup v-model="show" position="bottom">
    <div class="progress-popup" v-if="express">
      <div class="progress-popup__close" @click="close"><img src="@/assets/img/close.png" alt=""></div>
      <div class="progress-popup__title">{{ $t('express.title') }}</div>
      <div class="progress-popup__body">
        <div class="header" v-if="express && express.expressCompany">
          <div>{{ $t('express.courier') }}: {{ express.expressCompany }}</div>
          <div class="mg-t-4">{{ $t('express.trackingNumber') }}: {{ express.expressId }}</div>
        </div>
        <div class="progress">
          <div class="flex progress__item" :class="{ st: index === express.nodes.length - 1, ac: index === 0 }"
            v-for="(value, index) in express.nodes">
            <div class="dot"></div>
            <div class="right">
              <div class="time">{{ parseInt(value.time) | rentalDateTimeFormat }}</div>
              <div class="text">{{ value.event }}</div>
            </div>
          </div>
          <div v-if="isEmpty" class="empty-progress">
            <img src="@/assets/img/order/express_empty.png" alt="">
            <div>{{ $t('express.emptyTips') }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  name: 'ExpressProgress',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    express: {
      type: Object
    }
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.express || !this.express.nodes || this.express.nodes.length === 0;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    }
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  border-radius: 20px 20px 0 0;
}

.progress-popup {
  position: relative;

  &__close {
    position: absolute;
    right: 22px;
    top: 28px;
    width: 40px;
    height: 40px;

    img {
      margin: 8px auto;
      display: block;
      width: 24px;
      height: 24px;
    }
  }

  &__title {
    padding: 56px 30px 27px 30px;
    font-size: 42px;
    line-height: 48px;
  }
}

.header {
  padding: 22px 60px;
  background: #FEFAEE;
  font-size: 26px;
  color: var(--red-color);
  line-height: 31px;
}

.progress {
  padding: 50px 60px;
  font-size: 26px;
  line-height: 31px;
  height: 830px;
  box-sizing: border-box;
  overflow-y: scroll;
  --webkit-overflow-scrolling: touch;

  &__item {
    padding-bottom: 40px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 30px;
      left: 25px;
      height: 100%;
      z-index: -1;
      width: 0;
      border-right: 1px dashed var(--text-color-gray);
    }

    &:last-child::after {
      display: none;
    }

    &.ac {
      .dot {
        background: url('../assets/img/dot_03.png') no-repeat center/52px 52px;
      }

      .text {
        color: var(--primary-color);
        font-weight: 500;
      }
    }

    &.st {
      .dot {
        background: url('../assets/img/dot_01.png') no-repeat center/52px 52px;
      }
    }

    &.ac.st {
      .dot {
        background: url('../assets/img/dot_01_ac.png') no-repeat center/52px 52px;
      }
    }
  }
}

.dot {
  width: 52px;
  height: 52px;
  background: url('../assets/img/dot_02.png') no-repeat center/30px 30px;
}

.right {
  padding-left: 28px;
  flex: 1;
}

.time {
  font-size: 26px;
  color: var(--text-color-gray);
  line-height: 31px;
}

.text {
  margin-top: 12px;
}

.empty-progress {
  margin-top: 120px;
  text-align: center;

  img {
    width: 240px;
    height: 240px;
    display: block;
    margin: auto;
  }

  div {
    margin-top: 34px;
    font-size: 26px;
    font-size: 26px;
    line-height: 31px;
  }
}
</style>
